<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="file_005">contents</a></h2><a id="file_005">
</a><p class="cont"><a id="file_005"></a><a class="nounder" href="#/xhtml/file_007#file_007">introduction</a></p>
<p class="cont"><a class="nounder" href="#/xhtml/file_011#file_011">materials</a></p>
<p class="cont"><a class="nounder" href="#/xhtml/file_023#file_023">basic techniques</a></p>
<p class="cont1"><strong><a class="nounder" href="#/xhtml/file_031#file_031">bug magnets</a></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_047#file_047" title="Link target outside of Sample">penguin &amp; chick</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_078#file_078" title="Link target outside of Sample">butterfly pin</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_090#file_090" title="Link target outside of Sample">bunny</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_105#file_105" title="Link target outside of Sample">owl</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_134#file_134" title="Link target outside of Sample">goldfinch</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_154#file_154" title="Link target outside of Sample">turtle</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_176#file_176" title="Link target outside of Sample">bat</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_189#file_189" title="Link target outside of Sample">chicken &amp; chicks</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_212#file_212" title="Link target outside of Sample">hummingbird</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_232#file_232" title="Link target outside of Sample">clownfish</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_244#file_244" title="Link target outside of Sample">chipmunk</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_269#file_269" title="Link target outside of Sample">border collie</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_298#file_298" title="Link target outside of Sample">cat</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_320#file_320" title="Link target outside of Sample">frog</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_345#file_345" title="Link target outside of Sample">sheep</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_375#file_375" title="Link target outside of Sample">pink pig</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_400#file_400" title="Link target outside of Sample">giraffe</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_435#file_435" title="Link target outside of Sample">mermaid</span></strong></p>
<p class="cont"><strong><span class="nounder" href="#/xhtml/file_470#file_470" title="Link target outside of Sample">gnome girl</span></strong></p>
<p class="cont1"><span class="nounder" href="#/xhtml/file_509#file_509" title="Link target outside of Sample">gallery</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_516#file_516" title="Link target outside of Sample">resources</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_517#file_517" title="Link target outside of Sample">about the author</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_518#file_518" title="Link target outside of Sample">acknowledgment</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_005.vue?7389a348